import type { OrgTreeServiceInstance } from '@/services/org-tree'

const usableLogo = (value: unknown): string | null => {
  const text = String(value ?? '').trim()
  if (!text || text.toLowerCase() === 'null' || text.toLowerCase() === 'none') {
    return null
  }
  return text
}

export function resolveServiceInstanceAuthLogos(instance: OrgTreeServiceInstance | null | undefined) {
  const sidePanelLogos = [
    usableLogo(instance?.side_panel_logo),
    usableLogo(instance?.logo),
    usableLogo(instance?.login_page_logo),
    usableLogo(instance?.welcome_page_logo),
  ].filter(Boolean)

  const welcomeLogos = [
    usableLogo(instance?.logo),
    usableLogo(instance?.welcome_page_logo),
    usableLogo(instance?.login_page_logo),
    usableLogo(instance?.side_panel_logo),
  ].filter(Boolean)

  return {
    sidePanelLogo: sidePanelLogos[0] ?? null,
    welcomeLogo: welcomeLogos[0] ?? null,
    sidePanelLogos,
    welcomeLogos,
  }
}
